import { Injectable, OnDestroy } from "@angular/core";
import { Event } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class ArticleCompareI18n implements OnDestroy {

	private m_subscriptionsSubject = new Subject();

	public articleCompareDoubleText: string = 'Artikel schon vorhanden';
	public articleCompareLengthText: string = 'nicht mehr als 5 Artikel';
	public globalBasketAddItemSuccess: string = 'Erfolgreich hinzugefügt';
	public orderCreateAvailable: string = 'Artikel nicht verfügbar';

	constructor(
		private m_translateService: TranslateService
	) {
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('ARTICLE.COMPARE.UI.MESSAGE_DOUBLE.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.articleCompareDoubleText = res;
			}
		});

		this.m_translateService.get('ARTICLE.COMPARE.UI.MESSAGE_LENGTH.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.articleCompareLengthText = res;
			}
		});

		this.m_translateService.get('GLOBAL.BASKET_SERVICE.MESSAGE_ADD_ITEM_SUCCESS.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.globalBasketAddItemSuccess = res;
			}
		});

		this.m_translateService.get('ORDER.CREATE.UI.AVAILABLE.TEXT').pipe(
			takeUntil(this.m_subscriptionsSubject)
		).subscribe({
			next: (res: string) => {
				this.orderCreateAvailable = res;
			}
		});
	}
}
